import type { FaireProductEntity } from "../../entity_types/product";

export const p_9x92jbg5hq: FaireProductEntity = {
  token: "p_9x92jbg5hq",
  type: "product",
  name: "Baseball Mom",
  brandToken: "b_spqpp3hgqu",
  brandName: "Southern Backroad Tees LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/9aa262a61733e3c9d7f35eeffa17c6849f16b8762897eda046184b7a088684fe.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0005fce15fb23e0cfdbcd7bbbd638db64bd94f96d24dd46866460c87f898305c.png",
  ],
  priceDollars: 14,
  description:
    "-Bella Canvas 100% cotton short sleeve- Natural \n\n-Gildan Sweatshirt 50/50- Sand\n\n-design is pressed using dtf printing \n\n-Wash shirt inside out, no fabric softener and tumbler dry low. \n\n\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:56.350Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
